"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ToggleButton_styled_exports = {};
__export(ToggleButton_styled_exports, {
  StyledLabel: () => StyledLabel,
  StyledMarker: () => StyledMarker,
  StyledToggleButton: () => StyledToggleButton,
  StyledToggleButtonContainer: () => StyledToggleButtonContainer
});
module.exports = __toCommonJS(ToggleButton_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var getBorderColor = function getBorderColor2(theme, disabled, darkMode) {
  if (darkMode) {
    return theme.colors.beige[180];
  }
  return disabled ? theme.colors.beige[140] : theme.colors.beige[180];
};
var getToggleButtonBackgroundColor = function getToggleButtonBackgroundColor2(theme, isOn, variant, disabled, darkMode, backgroundColor) {
  var state = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : "resting";
  if (disabled) {
    return darkMode ? theme.colors.n[80] : theme.colors.n[10];
  }
  if (isOn && backgroundColor) {
    return backgroundColor;
  }
  switch (state) {
    case "resting":
      if (isOn) {
        return variant === "green" ? theme.colors.olive[100] : theme.colors.terracotta[100];
      }
      return theme.colors.beige[120];
    case "hover":
      if (isOn) {
        if (darkMode) {
          return variant === "green" ? theme.colors.olive[140] : theme.colors.terracotta[80];
        }
        return variant === "green" ? theme.colors.olive[100] : theme.colors.terracotta[80];
      }
      return darkMode ? theme.colors.beige[60] : theme.colors.beige[120];
    case "active":
      if (isOn) {
        if (darkMode) {
          return variant === "green" ? theme.colors.olive[80] : theme.colors.terracotta[100];
        }
        return variant === "green" ? theme.colors.olive[100] : theme.colors.terracotta[100];
      }
      return darkMode ? theme.colors.beige[60] : theme.colors.beige[120];
    default:
      if (isOn) {
        return variant === "green" ? theme.colors.olive[100] : theme.colors.terracotta[100];
      }
      return theme.colors.beige[120];
  }
};
var getToggleButtonBoxShadow = function getToggleButtonBoxShadow2(theme, disabled, darkMode) {
  if (disabled) {
    return "none";
  }
  return "".concat(darkMode ? theme.colors.black : theme.colors.white, " 0px 0px 0px 2px, ").concat(theme.colors.beige[180], " 0px 0px 0px 3px");
};
var getMarkerBackgroundColor = function getMarkerBackgroundColor2(theme, disabled, darkMode) {
  if (darkMode) {
    return disabled ? theme.colors.n[30] : theme.colors.white;
  }
  return disabled ? theme.colors.n[10] : theme.colors.white;
};
var getMarkerColor = function getMarkerColor2(theme, variant, disabled) {
  if (disabled) {
    return theme.colors.n[60];
  }
  return variant === "green" ? theme.colors.pr.base : theme.colors.black;
};
var getLabelColor = function getLabelColor2(theme, disabled, darkMode) {
  if (darkMode) {
    return disabled ? theme.colors.n[30] : theme.colors.white;
  }
  return disabled ? theme.colors.n[60] : theme.colors.black;
};
var StyledToggleButtonContainer = import_styled_components.default.div.withConfig({
  displayName: "ToggleButtonstyled__StyledToggleButtonContainer",
  componentId: "sc-1p73iqw-0"
})(function(_ref) {
  var disabled = _ref.disabled;
  return (0, import_styled_components.css)(["position:relative;display:inline-flex;align-items:center;padding:0;margin:0;cursor:", ";&:focus{outline:none;}"], disabled ? "not-allowed" : "pointer");
});
var StyledLabel = import_styled_components.default.label.withConfig({
  displayName: "ToggleButtonstyled__StyledLabel",
  componentId: "sc-1p73iqw-1"
})(function(_ref2) {
  var theme = _ref2.theme, customizedWidth = _ref2.customizedWidth;
  return (0, import_styled_components.css)(["font-family:", ";font-weight:", ";font-size:", ";line-height:20px;margin-left:8px;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;cursor:inherit;width:", ";"], theme.typography.fonts.primary, theme.typography.weights.regular, theme.typography.sizes.small, customizedWidth);
});
var StyledMarker = import_styled_components.default.span.withConfig({
  displayName: "ToggleButtonstyled__StyledMarker",
  componentId: "sc-1p73iqw-2"
})(["box-sizing:border-box;border:1px solid;border-radius:12px;display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;position:absolute;top:-1px;transition:all 0.3s;"]);
var StyledToggleButton = import_styled_components.default.div.withConfig({
  displayName: "ToggleButtonstyled__StyledToggleButton",
  componentId: "sc-1p73iqw-3"
})(function(_ref3) {
  var theme = _ref3.theme, _ref3$isOn = _ref3.isOn, isOn = _ref3$isOn === void 0 ? false : _ref3$isOn, _ref3$variant = _ref3.variant, variant = _ref3$variant === void 0 ? "green" : _ref3$variant, _ref3$disabled = _ref3.disabled, disabled = _ref3$disabled === void 0 ? false : _ref3$disabled, _ref3$darkMode = _ref3.darkMode, darkMode = _ref3$darkMode === void 0 ? false : _ref3$darkMode, markerColor = _ref3.markerColor, backgroundColor = _ref3.backgroundColor;
  return (0, import_styled_components.css)(["position:relative;display:inline-block;box-sizing:border-box;width:50px;height:24px;border:1px solid;border-color:", ";border-radius:12px;background-color:", ";transition:all 0.3s;& > ", "{background-color:", ";border-color:", ";left:", ";color:", ";}& + ", "{color:", ";}&:hover{border-color:", ";background-color:", ";& > ", "{border-color:", ";}}", ":focus > &{outline:none;box-shadow:", ";}", ":active > &{background-color:", ";}"], getBorderColor(theme, disabled, darkMode), getToggleButtonBackgroundColor(theme, isOn, variant, disabled, darkMode, backgroundColor), StyledMarker, isOn && markerColor ? markerColor : getMarkerBackgroundColor(theme, disabled, darkMode), getBorderColor(theme, disabled, darkMode), isOn ? "25px" : "-1px", getMarkerColor(theme, variant, disabled), StyledLabel, getLabelColor(theme, disabled, darkMode), darkMode || disabled ? getBorderColor(theme, disabled, darkMode) : theme.colors.black, getToggleButtonBackgroundColor(theme, isOn, variant, disabled, darkMode, backgroundColor, "hover"), StyledMarker, darkMode || disabled ? getBorderColor(theme, disabled, darkMode) : theme.colors.black, StyledToggleButtonContainer, getToggleButtonBoxShadow(theme, disabled, darkMode), StyledToggleButtonContainer, getToggleButtonBackgroundColor(theme, isOn, variant, disabled, darkMode, backgroundColor, "active"));
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledLabel,
  StyledMarker,
  StyledToggleButton,
  StyledToggleButtonContainer
});
//# sourceMappingURL=ToggleButton.styled.js.map